export const faqData = [
  {
    id: 1,
    question: "How is the EMI for a Personal Loan at SBI calculated?",
    answer:
      "The EMI is calculated based on the principal loan amount, interest rate, and loan tenure. The formula used is standard across banks but may differ based on individual bank policies and charges.",
  },
  {
    id: 2,
    question: "Can I change the loan tenure after my loan has been sanctioned?",
    answer:
      "Generally, once your loan has been approved, the tenure cannot be changed. However, you may apply for part-prepayment or opt for a top-up loan if needed.",
  },
  {
    id: 3,
    question: "How does my credit score affect the EMI for my Personal Loan?",
    answer:
      "A higher credit score (750+) may help you secure a loan with a lower interest rate, which can reduce your EMI. A lower credit score (below 650) may result in higher interest rates and, therefore, higher EMIs.",
  },
  {
    id: 4,
    question: " What are the processing fees for an SBI Personal Loan?",
    answer:
      "SBI charges processing fees between ₹1,000 and ₹5,000, depending on the loan amount and type of loan. Be sure to check the exact fee at the time of application.",
  },
  {
    id: 5,
    question: "Can I prepay my SBI Personal Loan?",
    answer:
      "Yes, SBI offers prepayment facilities that allow you to reduce your loan balance early. However, ensure you inquire about any associated prepayment charges, if applicable.",
  },
  {
    id: 6,
    question: "Is it better to choose a longer tenure for a lower EMI?",
    answer:
      "While a longer tenure results in a lower EMI, it increases the total repayment due to higher interest. It is important to balance your monthly affordability with the overall cost.",
  },
];
